/**
 * localStorage (SPEC.md「画面」)
 *
 * - `voter_id`: クライアントが生成する UUID v4。1人1票の単位
 * - 投票済みの読み方: **単語をキーに上書き保存**する。
 *   DB側が UNIQUE(word, voter_id) の上書きであるため、複数保持するとDBと乖離する。
 */

const VOTER_ID_KEY = 'yomikata:voter_id'
const VOTED_KEY = 'yomikata:voted'

/** プライベートモードなどで localStorage が使えないときのフォールバック */
const memory = new Map<string, string>()

function readItem(key: string): string | null {
  try {
    return localStorage.getItem(key)
  } catch {
    return memory.get(key) ?? null
  }
}

function writeItem(key: string, value: string): void {
  try {
    localStorage.setItem(key, value)
  } catch {
    memory.set(key, value)
  }
}

export function getVoterId(): string {
  const stored = readItem(VOTER_ID_KEY)
  if (stored) return stored
  const generated = crypto.randomUUID()
  writeItem(VOTER_ID_KEY, generated)
  return generated
}

function readVotedMap(): Record<string, string> {
  const raw = readItem(VOTED_KEY)
  if (!raw) return {}
  try {
    const parsed: unknown = JSON.parse(raw)
    if (parsed && typeof parsed === 'object' && !Array.isArray(parsed)) {
      return parsed as Record<string, string>
    }
  } catch {
    // 壊れていたら捨てる
  }
  return {}
}

/** その単語で投票済みの読み方 */
export function getVoted(word: string): string | null {
  return readVotedMap()[word] ?? null
}

/** 単語をキーに上書き保存する */
export function setVoted(word: string, pronunciation: string): void {
  const map = readVotedMap()
  map[word] = pronunciation
  writeItem(VOTED_KEY, JSON.stringify(map))
}
